

@if (settingWithData && FC) {
  <div class="field" [class.loading-box]="loading">

    @if (settingWithData.dataType !== DataType.TITLES && settingWithData.dataType !== DataType.CHECKBOX) {
      <p class="m-0 text-xs mb-1">
        {{ settingWithData.label }}
      </p>
    }
    @switch(settingWithData.dataType) {
      @case(DataType.PHONE_NUMBER) {
        <app-phone-number-input [FC]="$any(FC)"></app-phone-number-input>
      }
      @case(DataType.STRING) {
        <input type="text" pInputText [formControl]="$any(FC)" class="w-full">
      }
      @case(DataType.CUSTOM_TAGS) {
        <p-autoComplete
          #autoComplete
          [delay]="0"
          [formControl]="$any(FC)"
          [suggestions]="filteredLecturerTopics"
          class="p-fluid block"
          [multiple]="true"
          [autoHighlight]="true"
          [completeOnFocus]="true"
          (completeMethod)="search($event)"
          (keydown.enter)="setAutoCompleteValue()"/>
      }
      @case (DataType.TEXT) {
        <textarea pInputTextarea [formControl]="$any(FC)" class="w-full"></textarea>
      }
      @case (DataType.BANK_ACCOUNT) {
        <input type="text" pInputText [formControl]="$any(FC)" class="w-full">
      }
      @case (DataType.LINK) {
        <p-inputGroup>
          <input type="text" pInputText [formControl]="$any(FC)" class="w-full">
          @if (FC.value?.length > 0) {
            <p-inputGroupAddon>
              <a [href]="FC.value | externalHref" target="_blank" rel="noopener noreferrer">
                <i class="pi pi-external-link"></i>
              </a>
            </p-inputGroupAddon>
          }
        </p-inputGroup>
      }
      @case (DataType.MULTISELECT) {
        <p-multiSelect
          class="w-full"
          styleClass="w-full"
          [options]="settingWithData.options || []" 
          [formControl]="$any(FC)" 
          [placeholder]="settingWithData.label"
        />
      }
      @case (DataType.CHECKBOX) {
        <div class="flex align-items-center">
          <p-checkbox [binary]="true" [formControl]="$any(FC)" [inputId]="settingWithData.uuid"></p-checkbox>
          <label [for]="settingWithData.uuid" class="ml-2">{{ settingWithData.label }}</label>
        </div>
      }
      @case (DataType.TITLES) {
        <div class="flex pt-3">
          <app-titles-input [titlesFG]="$any(FC)" />
        </div>
      }
      @default {
        <!-- {{ utils.logError('Unhandled custom org member input ' + settingWithData.dataType + ' 09eruojisaogsai') }} -->
      }
    }
  </div>
}